import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import * as styles from './Tooltip.css';

interface ITooltipCustomProps {
    readonly isOpen?: boolean;
}

interface ITooltipProps {
    readonly master: React.ReactNode;
    readonly children: React.ReactNode;
    readonly custom: ITooltipCustomProps;
}

interface ITooltipState {
    isOpened: boolean;
    isVisible: boolean;
}

export class Tooltip extends React.PureComponent<ITooltipProps, ITooltipState> {
    public constructor(props: ITooltipProps) {
        super(props);

        const { custom: { isOpen } } = props;

        this.state = {
            isOpened: isOpen || false,
            isVisible: isOpen || false,
        };
    }

    public static getDerivedStateFromProps(props: ITooltipProps, state: ITooltipState) {
        const { custom: { isOpen } } = props;
        const { isOpened } = state;

        if (isOpened !== isOpen && isOpen) {
            return {
                isOpened: isOpen,
            };
        }

        return null;
    }

    public componentDidUpdate() {
        const { isOpened, isVisible } = this.state;
        const { custom: { isOpen } } = this.props;

        if (isOpen && isOpened && !isVisible) {
                this.setState({ isVisible: true });
        }

        if (!isOpen && isOpened && isVisible) {
                this.setState({ isVisible: false });
        }

        if (!isOpen && !isVisible && isOpened) {
            setTimeout(() => {
                this.setState({ isOpened: false });
            }, 300);
        }
    }

    public render() {
        const { master, children } = this.props;
        const { isOpened, isVisible } = this.state;

        return (
            <div className={styles['tooltip']}>
                <div className={styles['tooltip__target']}>
                    {master}
                </div>
                <div
                    {...mergeStyles(
                        styles['tooltip__plate'],
                        isOpened && styles['tooltip__plate_is_opened'],
                        isVisible && styles['tooltip__plate_is_visible'],
                    )}
                >
                    {children}
                </div>
            </div>
        );
    }
}
